import { Account } from '@/models/account'

export class Auth extends Account {
  public password: string
  public token: string
  public otp: string
  public forgotPassword: boolean
}
